import { Head, useForm, usePage, Link } from "@inertiajs/react";
import { Wrench } from "lucide-react";
import SignInCard from "@/components/auth/SignInCard";
import AuthShell from "@/components/auth/AuthShell";
import { Button } from "@/components/ui/button";

export default function SignIn({ dev_sign_in_options }) {
  const { routes, flash } = usePage().props;
  const { data, setData, post, processing, errors } = useForm({ email: "" });

  const submit = (e) => {
    e.preventDefault();
    post(routes.sign_in);
  };

  return (
    <AuthShell helpHref={routes.help}>
      <Head title="Sign in" />
      <SignInCard
        email={data.email}
        onEmailChange={(e) => setData("email", e.target.value)}
        onSubmit={submit}
        processing={processing}
        errorMessage={flash?.alert}
        errorEmail={errors.email}
      />
      <p className="mt-6 text-center text-sm text-muted-foreground">
        Got a take-home sheet with a code?{" "}
        <Link href={routes.activate} className="font-medium text-primary hover:underline">Activate your child</Link>
      </p>

      {dev_sign_in_options?.length > 0 && (
        <DevSignIn options={dev_sign_in_options} />
      )}
    </AuthShell>
  );
}

// Development only — the server sends `dev_sign_in_options` as nil in
// production, so this never renders there. Plain <a> (not Inertia Link)
// so the sign-in is a full request that sets the cookie and redirects.
function DevSignIn({ options }) {
  return (
    <div className="mt-6 rounded-lg border border-dashed border-warning/60 bg-warning/5 p-4">
      <p className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-warning-foreground mb-3">
        <Wrench className="h-3.5 w-3.5" />
        Dev only · skip the email
      </p>
      <div className="grid gap-2">
        {options.map((option, index) => (
          <Button key={option.label} variant={index === 0 ? "default" : "outline"} className="min-w-0 justify-between" asChild>
            <a href={option.href}>
              <span className="shrink-0">Sign in as {option.label.toLowerCase()}</span>
              <span className="min-w-0 truncate text-xs font-normal opacity-70">{option.email}</span>
            </a>
          </Button>
        ))}
      </div>
    </div>
  );
}

// Errors show inline next to the form, not as a toast too.
SignIn.inlineFlashAlerts = true;
